<template>
    <el-dialog :visible="visible" :modal-append-to-body="false" top="6vh" class="ah-detail-dialog declare-operation-hint-dialog" append-to-body :before-close="onClose">
        <template slot="title"> 匯入媒體檔 </template>
        <div class="container">
            <el-row :gutter="20">
                <el-col :sm="6">
                    <div class="intro-text">
                        <div class="title">媒體檔已下載</div>
                        <div class="sub">請開啟 <a class="link" href="https://tax.nat.gov.tw/alltax-download.html?id=2" target="_blank">營業稅電子申報繳稅軟體</a> ，進行媒體檔匯入。</div>
                    </div>
                </el-col>
                <el-col :sm="18">
                    <div class="img-block">
                        <img src="@/assets/img/tax-declare-upload-ex.jpg" />
                    </div>
                </el-col>
            </el-row>

            <el-button class="ok-btn" type="primary" @click="onClose">了解</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
    },
    methods: {
        onClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.declare-operation-hint-dialog {
    &.ah-detail-dialog .el-dialog {
        width: 100%;
    }

    .container {
        width: 100%;
        padding: 15px 50px 35px 50px;
        text-align: center;
    }
    .intro-text {
        font-size: 20px;
        font-weight: 700;
        text-align: left;
        margin-top: 10vh;

        .title {
            margin-bottom: 20px;
            text-align: center;
        }
        .sub {
            font-size: 12pt;
            font-weight: normal;
            line-height: 170%;
        }
    }
    .img-block {
        img {
            width: 100%;
        }
    }
    .ok-btn {
        width: 250px;
        margin-top: 20px;
    }

    .link {
        color: #463cb2;
    }
}
</style>
